import React from 'react';
import {
  ArrowUturnLeftIcon,
  ArrowUturnRightIcon,
  Bars3BottomLeftIcon,
  ListBulletIcon,
  NumberedListIcon,
} from '@heroicons/react/24/outline';

/**
 * Formatting toolbar pinned under the article section tabs.
 * Extracted verbatim from pages/Articles/Article.js.
 */
export default function ArticleEditorToolbar({
  convertCurrentBlock,
  runEditorCommand,
  selectedBlockType,
  setCurrentBlockStyle,
}) {
  return (
    <div className="editor-top-toolbar">
      <div className="editor-top-toolbar__group">
        <button type="button" title="Cofnij" onMouseDown={(e) => e.preventDefault()} onClick={() => runEditorCommand('undo')} className="editor-top-toolbar__icon-btn">
          <ArrowUturnLeftIcon className="h-4 w-4" />
        </button>
        <button type="button" title="Ponów" onMouseDown={(e) => e.preventDefault()} onClick={() => runEditorCommand('redo')} className="editor-top-toolbar__icon-btn">
          <ArrowUturnRightIcon className="h-4 w-4" />
        </button>
      </div>

      <span className="editor-top-toolbar__separator" />

      <div className="editor-top-toolbar__group">
        <select
          className="editor-top-toolbar__select"
          value={selectedBlockType}
          onChange={(e) => setCurrentBlockStyle(e.target.value)}
        >
          <option value="paragraph">Paragraf</option>
          <option value="header-2">Nagłówek H2</option>
          <option value="header-3">Nagłówek H3</option>
        </select>
      </div>

      <span className="editor-top-toolbar__separator" />

      <div className="editor-top-toolbar__group">
        <button type="button" title="Pogrubienie" onMouseDown={(e) => e.preventDefault()} onClick={() => runEditorCommand('bold')} className="editor-top-toolbar__icon-btn">
          <span className="font-semibold">B</span>
        </button>
        <button type="button" title="Kursywa" onMouseDown={(e) => e.preventDefault()} onClick={() => runEditorCommand('italic')} className="editor-top-toolbar__icon-btn">
          <span className="italic">I</span>
        </button>
        <button type="button" title="Podkreślenie" onMouseDown={(e) => e.preventDefault()} onClick={() => runEditorCommand('underline')} className="editor-top-toolbar__icon-btn">
          <span className="underline">U</span>
        </button>
        <button type="button" title="Przekreślenie" onMouseDown={(e) => e.preventDefault()} onClick={() => runEditorCommand('strikeThrough')} className="editor-top-toolbar__icon-btn">
          <span className="line-through">S</span>
        </button>
      </div>

      <span className="editor-top-toolbar__separator" />

      <div className="editor-top-toolbar__group">
        <button type="button" title="Wyrównaj do lewej" onMouseDown={(e) => e.preventDefault()} onClick={() => runEditorCommand('justifyLeft')} className="editor-top-toolbar__icon-btn">
          <Bars3BottomLeftIcon className="h-4 w-4" />
        </button>
        <button type="button" title="Lista punktowana" onMouseDown={(e) => e.preventDefault()} onClick={() => convertCurrentBlock('unordered')} className="editor-top-toolbar__icon-btn">
          <ListBulletIcon className="h-4 w-4" />
        </button>
        <button type="button" title="Lista numerowana" onMouseDown={(e) => e.preventDefault()} onClick={() => convertCurrentBlock('ordered')} className="editor-top-toolbar__icon-btn">
          <NumberedListIcon className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
